import React from "react"
import styled from "styled-components"
import { Button } from "buoy-core"
import { responsive } from "../../common/styledHelpers"
import Text from "../../common/components/Text"
import { description } from "../triageCopy"
// 4851-todo: update responsive helper

export const Icon = styled.img`
  width: 62px;
  height: 62px;
  flex: 0 0 62px;
  border-radius: 50%;
  background-color: white;
`

const Emergency = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 14px 14px 16px;
`

const CtaButton = styled(Button)`
  ${responsive("width", "190px", "100%")};
  margin-top: 14px;
`

const LinkWrapper = styled.a`
  display: flex;
  justify-content: center;
  text-decoration: none;
  ${responsive("width", "190px", "100%")};

  html.non-touch &:hover {
    text-decoration: none;
  }
`

const TriageStatement = ({acuity, recommendationSection, results }) => {
  return (
    acuity === 7 ? (
      <Emergency>
        <Text>{description[acuity]}</Text>
        <LinkWrapper href="tel:911">
          <CtaButton>
            Call 911
          </CtaButton>
        </LinkWrapper>
      </Emergency>
    ) : (
      <Text>{results.recommendation ? results.recommendation.explanation.text : description[acuity]}</Text>
    )
  )
}

export { TriageStatement as default }



// WEBPACK FOOTER //
// ./assets/completion/components/TriageStatement.js